import { LucideIcon } from "lucide-react";

import { TabsTrigger } from "@/components/ui/tabs";

type TTriggerTabProps = {
  value: string;
  Icon: LucideIcon;
  label: string;
};

const TriggerTab = ({
  value,
  Icon,
  label,
}: TTriggerTabProps): React.JSX.Element => {
  return (
    <TabsTrigger
      value={value}
      className='flex  flex-col gap-y-2 min-w-[6rem] group bg-transparent data-[state=active]:bg-transparent'
    >
      <p className='p-2 bg-primaryLight text-primary group-data-[state=active]:text-green-700 group-data-[state=active]:bg-green-300 font-medium rounded-lg flex items-center justify-center'>
        <Icon size={24} />
      </p>
      <p className='text-sm font-thin text-black group-data-[state=active]:text-green-700 capitalize'>
        {label}
      </p>
    </TabsTrigger>
  );
};

export default TriggerTab;
